import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Cómo recibo el material?',
  answer: <>
        <strong data-id="element-181" data-mp="1iwgfrxrogu43">Inmediatamente después del pago</strong> recibirás un enlace de
        descarga. Es un PDF que podés leer en <em data-id="element-182" data-mp="1nvkrow5zl5y4">cualquier dispositivo</em>.
      </>
}, {
  question: '¿Sirve si mi pareja no quiere participar?',
  answer: <>
        <strong data-id="element-183" data-mp="2flxvz6oadyk1">Sí.</strong> El material incluye una sección para aplicar{' '}
        <em data-id="element-184" data-mp="2fo1xxj2mknho">cambios unilaterales</em> que generan un impacto positivo en el
        vínculo, incluso si el otro no hace nada.
      </>
}, {
  question: '¿Es un pago único?',
  answer: <>
        <strong data-id="element-185" data-mp="26raw0q1e6ef6">Sí.</strong> Pagás una sola vez y tenés{' '}
        <em data-id="element-186" data-mp="2uigap1vlj0nw">acceso de por vida</em> al material. Sin suscripciones ni costos
        ocultos.
      </>
}, {
  question: '¿Tiene garantía?',
  answer: <>
        <strong data-id="element-187" data-mp="1vozr4jmpefby">Sí.</strong> Si el contenido no te aporta valor, tenés{' '}
        <em data-id="element-188" data-mp="1ro5zbf654gds">7 días para pedir la devolución total</em>. Sin preguntas, sin
        vueltas.
      </>
}];
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#110038]" data-id="element-189" data-mp="2fcz0pr5j7gfs">
      <div className="max-w-3xl mx-auto px-6" data-id="element-190" data-mp="2aens1jqz3bz5">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-191" data-mp="2advwg8xdle8v">
          <div className="text-center mb-16" data-id="element-192" data-mp="p3p1w1bl3ziz">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white text-center font-serif" data-id="element-193" data-mp="2p4lw5wrw1yhw">
              Preguntas Frecuentes
            </h2>
          </div>

          <div className="space-y-4" data-id="element-194" data-mp="2z1zy6rd2ekqo">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1,
            ease: 'easeOut'
          }} className="bg-[#1A0050] rounded-[20px] overflow-hidden border border-[#7C3AED]/30 shadow-sm" data-id="element-195" data-mp="2z44d04ci545q" data-mpi={index}>
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-[#7C3AED]/10 transition-colors" data-id="element-196" data-mp="1k4xdo56v3isu">
                  <span className="text-lg font-semibold text-white pr-4 font-sans" data-id="element-197" data-mp="165nyn8ue6uqg">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-198" data-mp="22udeyuqdffab">
                    <ChevronDownIcon className="w-5 h-5 text-[#7C3AED] flex-shrink-0" data-id="element-199" data-mp="1p4jpca71kqzj" />
                  </motion.div>
                </button>
                <motion.div initial={false} animate={{
              height: openIndex === index ? 'auto' : 0,
              opacity: openIndex === index ? 1 : 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-200" data-mp="2ml8qs2s2xr8e">
                  <div className="px-8 pb-6 text-[#C4B5FD] leading-relaxed font-sans" data-id="element-201" data-mp="1sdt5mxam77vj">
                    {faq.answer}
                  </div>
                </motion.div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}